export function buildParlorLocalBusinessSchema(
  parlor: {
    companyname: string;
    address: string;
    latitude?: number | string | null;
    longitude?: number | string | null;
    binsos?: Array<{ item?: string; charge?: number; pyeong?: number }>;
  },
  canonicalUrl?: string
) {
  const schema: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": parlor.companyname,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": parlor.address,
      "addressCountry": "KR",
    },
    "openingHours": "Mo-Su 00:00-24:00",
    "telephone": "+82-1577-4129",
  };

  if (parlor.latitude && parlor.longitude) {
    schema["geo"] = {
      "@type": "GeoCoordinates",
      "latitude": Number(parlor.latitude),
      "longitude": Number(parlor.longitude),
    };
  }

  if (canonicalUrl) {
    schema["url"] = canonicalUrl;
  }

  if (parlor.binsos && parlor.binsos.length) {
    const charges = parlor.binsos
      .map((b) => b.charge || 0)
      .filter((c) => c > 0);
    if (charges.length) {
      const minCharge = Math.min(...charges);
      const maxCharge = Math.max(...charges);
      schema["priceRange"] = `₩${minCharge.toLocaleString()} - ₩${maxCharge.toLocaleString()} / day`;
    }
    schema["makesOffer"] = parlor.binsos.map((b) => ({
      "@type": "Offer",
      "name": `빈소 (${b.pyeong || 0}평)`,
      "priceCurrency": "KRW",
      "price": String(b.charge || 0),
      "description": `${b.item || ""}, 1일 사용료`,
      "priceSpecification": {
        "@type": "UnitPriceSpecification",
        "unitText": "DAY",
        "price": String(b.charge || 0),
        "priceCurrency": "KRW",
      },
    }));
  }

  return schema;
}
